import React, { useCallback, useEffect } from 'react';
import { Field, FieldArray, useField } from 'formik';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import AddIcon from '@material-ui/icons/Add';
import { TextField } from 'components/form/Formik/index';

const OptionItem = React.memo(({ parentFieldName, index, remove }) => {
  return (
    <Grid container spacing={2} alignItems={'center'}>
      <Grid item md={6}>
        <TextField
          variant="outlined"
          margin="dense"
          placeholder="Add option"
          name={`${parentFieldName}.choices[${index}]`}
        />
      </Grid>
      <Grid item>
        <IconButton color="secondary" onClick={() => remove(index)}>
          <DeleteForeverIcon />
        </IconButton>
      </Grid>
    </Grid>
  );
});

const QuestionRadioOptions = ({ name: parentFieldName }) => {
  const [field, meta, helpers] = useField(parentFieldName);

  useEffect(() => {
    if (!field.value.choices) {
      field.value.choices = [''];
      helpers.setValue(field.value);
    }
  }, []);

  return (
    <div>
      <FieldArray
        name={`${parentFieldName}.choices`}
        render={(arrayHelpers) => (
          <div>
            {field.value?.choices?.map((c, i) => (
              <OptionItem
                key={i}
                index={i}
                parentFieldName={parentFieldName}
                remove={arrayHelpers.remove}
              />
            ))}
            <Button
              variant="outlined"
              size="small"
              color="primary"
              onClick={() => arrayHelpers.push('')}
              startIcon={<AddIcon />}
            >
              Add Option
            </Button>
          </div>
        )}
      />
    </div>
  );
};

export default React.memo(QuestionRadioOptions);
